import { h } from 'preact';
import { useAdParameters } from '../hooks/useAdParameters';
import { useOptimizedAsset } from '../hooks/useOptimizedAsset';
import { headBg, typography } from '../theme';

interface IGHeaderProps {
  brand_name: string;
  logo: { uri: string; placeholder?: string };
}

const headerWrapper = {
  background: headBg,
  height: 60,
};

const brandWrapper = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBlockStart: 16,
  marginBlockEnd: 12,
  marginInlineStart: 16,
  marginInlineEnd: 16,
};

export const brandText = {
  ...typography.primary,
  fontWeight: 600,
  maxHeight: typography.primary.lineHeight,
  overflow: 'hidden',
};

const sponsoredText = {
  ...typography.secondary,
  fontWeight: 'normal',
};

const brandLogo = {
  width: 32,
  height: 32,
  borderRadius: '50%',
  border: '1px solid #F1F1F1',
  boxSizing: 'border-box',
  objectFit: 'contain',
};

export function InstagramHeader() {
  const { config = {} } = useAdParameters<any>();
  const { brand_name, logo = {} } = config;
  const logoUri = useOptimizedAsset(logo);
  const logoSrc = logoUri || logo.placeholder;
  return (
    <div style={headerWrapper}>
      <div style={brandWrapper}>
        {logoSrc && <img style={brandLogo} src={logoSrc} />}
        <div style={{ marginInlineStart: '12px' }}>
          <div style={brandText}>{brand_name}</div>
          <div style={sponsoredText}>Sponsored</div>
        </div>
      </div>
    </div>
  );
}
